/**
 * 
 * key
 * 
 */


const key = 'Y2xpZW50X3Byb2ZpbGU='

export default key 